import React, { useState } from "react";
import "../styles/floatingLabelInput.css";

const FloatingLabelInput = ({
    label,
    value,
    onChange,
    type = "text",
    maxLength,
    disabled = false,
    error = false,
    errorMessage = "",
    required = false,
    errorAlign = "left",
    keepLabelColor = false,
    keepBorderColor = false,
    errorStyle,
    placeholder,
    ...props
}) => {

    const [focused, setFocused] = useState(false);

    const floating = focused || value;

    return (
        <div
            className={`floating-input-wrapper ${focused ? "focused" : ""
                } ${error ? "error" : ""} ${disabled ? "disabled" : ""
                }`}
        >
            <label
                className={`floating-label ${floating ? "floating" : ""
                    }`}
                style={error && keepLabelColor ? { color: "#636363" } : undefined}
            >
                {label}
                {required && (
                    <span className="required">*</span>
                )}
            </label>

            <input
                {...props}
                type={type}
                value={value}
                disabled={disabled}
                maxLength={maxLength}
                // Shown only once the label has floated up, so it never overlaps the label.
                placeholder={floating ? placeholder : ""}
                onFocus={() => setFocused(true)}
                onBlur={() => setFocused(false)}
                onChange={onChange}
                className="floating-input"
                style={error && keepBorderColor ? { borderBottom: "1px solid #E6E6E6" } : undefined}
            />
            {error && errorMessage && (
                <div
                    className="floating-error"
                    style={{
                        ...(errorAlign === "right" ? { textAlign: "right", fontSize: "10px" } : {}),
                        ...errorStyle,
                    }}
                >
                    {errorMessage}
                </div>
            )}
        </div>
    );
};

export default FloatingLabelInput;